import Modal from '@mui/material/Modal'
import { Box, Button, IconButton, TextField, Typography, useMediaQuery } from '@mui/material'
import CancelButton from '../../assets/images/CancelButton.svg'
import { useFormik } from 'formik'
import * as React from 'react'
import { FORMIK_VALUE, VALIDATION_SCHEMA } from './consts'
import useToken from '../../hooks/useToken'
import { usePostChangePasswordMutation } from '../../redux/api/userApi'
import { useEffect } from 'react'
import ErrorMessage from '../ErrorMessage'
import AlertNotification from '../AlertNotification/AlertNotification'
import { useTheme } from '@mui/material/styles'

const UpdatePassword = ({
  isShowUpdatePasswordModal,
  setIsShowUpdateModal
}: any) => {
  const isError = false
  const handleClose = () => {
    setIsShowUpdateModal(false)
    formikUpdatePassword.resetForm()
  }
  const [changePassword, { isLoading: isLoadingChangePassword, isSuccess: isSuccessChangePassword, error: changeError }] = usePostChangePasswordMutation()
  const { xsrf, isLoading: isLoadingXsrf } = useToken()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  useEffect(() => {
    if (isSuccessChangePassword) {
      handleClose()
    }
  }, [isSuccessChangePassword])

  const formikUpdatePassword = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    initialValues: {
      [FORMIK_VALUE.ORIGINAL_PASSWORD]: '',
      [FORMIK_VALUE.NEW_PASSWORD]: '',
      [FORMIK_VALUE.CONFIRM_PASSWORD]: ''
    },
    validationSchema: VALIDATION_SCHEMA,
    onSubmit: async (values) => {
      await changePassword({
        xsrf,
        body: {
          password: values[FORMIK_VALUE.ORIGINAL_PASSWORD],
          newPassword: values[FORMIK_VALUE.NEW_PASSWORD],
          newPasswordConfirmation: values[FORMIK_VALUE.CONFIRM_PASSWORD]
        }
      })
    }
  })

  const submit = async (e: any) => {
    e.preventDefault()
    await formikUpdatePassword.submitForm()
  }

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '100%' : 592,
    minHeight: isMobile ? '100%' : 332,
    bgcolor: 'background.paper',
    borderRadius: isMobile ? 0 : '15px',
    boxShadow: 24,
    p: '40px 40px 48px 40px'
  }

  const config = [
    {
      id: 0,
      label: 'Original Password',
      formikName: FORMIK_VALUE.ORIGINAL_PASSWORD
    },
    {
      id: 1,
      label: 'New Password',
      formikName: FORMIK_VALUE.NEW_PASSWORD
    },
    {
      id: 2,
      label: 'Confirm New Password',
      formikName: FORMIK_VALUE.CONFIRM_PASSWORD
    }
  ]

  return <Box>
      {isSuccessChangePassword && <AlertNotification text="Password updated successfully" />}
        <Modal
            open={isShowUpdatePasswordModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: isMobile ? '100%' : 512,
                  height: 40,
                  mb: '34px'
                }}>
                    <Typography sx={{ fontSize: '16px' }}>
                        Change Password
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <Box component="img" src={CancelButton}/>
                    </IconButton>
                </Box>
                <form onSubmit={submit} noValidate >
                    {config.map((el) => {
                      return <label key={el.id}>
                            <Typography sx={{
                              fontFamily: 'Roboto',
                              fontSize: '14px',
                              fontWeight: 700,
                              lineHeight: '30px',
                              marginBottom: '8px'
                            }}>
                                {el.label}
                            </Typography>
                            <TextField
                                error={!!(formikUpdatePassword.touched[el.formikName] &&
                                formikUpdatePassword.errors?.[el.formikName])}
                                aria-invalid={isError}
                                onBlur={async (e) => {
                                  formikUpdatePassword.handleBlur(e)
                                  await formikUpdatePassword.setFieldTouched(el.formikName, true)
                                }}
                                onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                  await formikUpdatePassword.setFieldValue(el.formikName, e.currentTarget.value)
                                }}
                                value={formikUpdatePassword.values[el.formikName]}
                                type='password'
                                fullWidth
                            />
                          {formikUpdatePassword.touched[el.formikName] &&
                          formikUpdatePassword.errors?.[el.formikName] && <Typography sx={{
                            marginTop: '10px',
                            color: '#E84419'
                          }}>
                              {formikUpdatePassword.errors?.[el.formikName]}
                            </Typography>}
                        </label>
                    })}
                    <ErrorMessage error={changeError} />
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'end',
                      marginTop: '49px'
                    }}>
                    <Button sx={{
                      border: '#F5F6F7',
                      boxShadow: '0px 2px 5px 0px rgba(38, 51, 77, 0.03)',
                      color: '#6B7A99',
                      background: '#FFF',
                      marginRight: '21px'
                    }} onClick={handleClose} >Close</Button>
                    <Button disabled={!formikUpdatePassword.isValid || isLoadingXsrf || isLoadingChangePassword} sx={{
                      border: '2px solid #09B5EC',
                      background: '#09B5EC',
                      '&:hover': {
                        background: '#09B5EC'
                      },
                      '&:disabled': {
                        color: 'rgba(0, 0, 0, 0.26)',
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        background: 'inherit'
                      }
                    }} type='submit'>Save Changes</Button>
                    </Box>
                </form>
            </Box>
        </Modal>
    </Box>
}

export default UpdatePassword
